import { Alert as ChakraAlert, AlertProps as ChakraAlertProps } from '@chakra-ui/react';

const Alert = ({ children, ...props }: ChakraAlertProps) => {
  const { status, variant = 'subtle' } = props;

  const statusProps =
    status === 'info'
      ? {
          bgColor: 'primaryThemeColour.400',
        }
      : {};

  const variantProps =
    variant === 'subtle'
      ? {
          color: 'base2FontColour.500',
          bgColor: 'red.100',
        }
      : {
          color: 'base1FontColour.500',
        };

  return (
    <ChakraAlert {...variantProps} {...statusProps} {...props}>
      {children}
    </ChakraAlert>
  );
};

export { Alert };
